import { type WithChildren } from "@common/declarations";
import * as React from "react";

export type ErrorBoundaryProps = WithChildren & {
  hideError?: boolean;
  additionalLogInfo?: string;
  error?: string;
};
interface State {
  error: Error | null;
}

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, State> {
  public state: State = {
    error: null
  };

  public static getDerivedStateFromError(error: Error): State {
    // Update state so the next render will show the fallback UI.
    return { error };
  }

  public componentDidCatch(error: Error, info: React.ErrorInfo) {
    // You can also log the error to an error reporting service
    console.error(`${this.props.additionalLogInfo || ""}${error.message}`);
  }

  public render() {
    if (this.state.error) {
      return this.props.hideError ? null : this.props.error ? (
        <div>{this.props.error}</div>
      ) : (
        <div>
          Unexpected error has occurred: {this.state.error.message}
          <pre>{this.state.error.stack}</pre>
        </div>
      );
    }

    return this.props.children;
  }
}
